import React from 'react';
import PropTypes from 'prop-types';
import BarsIcon from 'react-icons/lib/fa/bars';
import Styles from './styles';
import Button from '../UIKit/Button';

const HamburgerButton = props => (
  <Button onClick={props.onClick} style={Styles.wrapper}>
    <div style={Styles.inner}>
      <BarsIcon size={20} style={Styles.socialLogin} />
      <img alt="" style={Styles.logo} src={require('../../assets/images/logo.png')} />
    </div>
  </Button>
);

HamburgerButton.propTypes = {
  onClick: PropTypes.func,
};

HamburgerButton.defaultProps = {
  onClick: () => {},
};

export default HamburgerButton;



// WEBPACK FOOTER //
// ./src/components/HamburgerButton/index.js